import { lazy } from "react";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AutomobileBasicDetails } from "./AutomobileBasicDetails/AutomobileBasicDetails";
import { AutoDriverRoot } from "./AutomobileDriverRoot";
import { AutoVehicleRoot } from "./AutomobileVehicleRoot";
import { AutomobileVehiclePage } from "./AutomobileVehicle/AutomobileVehiclePage";
import { AutomobileScheduleAList } from "./AutomobileSchedule/AutomobileScheduleA/AutomobileScheduleAList";
import { AutomobileScheduleAPage } from "./AutomobileSchedule/AutomobileScheduleA/AutomobileScheduleAPage";
import { AutomobilePolicyForms } from "./AutomobilePolicyForms/AutomobilePolicyForms";
import { AutomobileConsentForm } from "./AutomobilePolicyForms/AutomobileConsentForm/AutomobileConsentForm";
import { AutomobileRetireeDiscount } from "./AutomobilePolicyForms/AutomobileRetireeDiscount/AutomobileRetireeDiscount";
import { AutomobileSharingFillable } from "./AutomobilePolicyForms/AutomobileSharingFillable/AutomobileSharingFillable";
import { AutomobileCSIOApplicationTab } from "./AutomobileCSIOApplicationTab";
import { AutomobileCSIOEDocsList } from "./AutomobileCSIOEDocs/AutomobileCsioEDocsList";
import { AutomobileCSIOEDocsWrapper } from "./AutomobileCSIOEDocs/AutomobileCSIOEDocsWrapper";
import { AutomobileCSIOEDIList } from "./AutomobileCSIOEDIList/AutomobileCSIOEDIList";
import { AutomobilePolicyChangeReqForm } from "./AutomobilePolicyChangeRequest/AutomobilePolicyChangeReqForm";
import { AutomobileApplicationRoot } from "./ApplicationRoot";
import { AutomobileNoteFormList } from "./AutomobileNoteForm/AutomobileNoteFormList";
import { AutomobileTaskActivity } from "./TaskActivity/TaskActivity";
import { AutoG4SignRouter } from "./AutomobileG4Sign/AutomobileG4Sign.router";
import { AutomobileMpoiWrapper } from "./AutomobileCSIOMpoi/AutomobileMpoiWrapper";




const AutomobileDriverInformation = Loadable(
  lazy(() =>
    import(
      "./AutomobileDriver/AutomobileDriverInformation/AutomobileDriverInformationPage"
    ).then(({ AutomobileDriverInformationPage }) => ({
      default: AutomobileDriverInformationPage,
    }))
  )
);
const AutomobileInsuranceLapse = Loadable(
  lazy(() =>
    import(
      "./AutomobileDriver/AutomobileInsuranceLapse/AutomobileInsuranceLapse"
    ).then(({ AutomobileInsuranceLapse }) => ({
      default: AutomobileInsuranceLapse,
    }))
  )
);
const AutomobileFraudMisRepresent = Loadable(
  lazy(() =>
    import(
      "./AutomobileDriver/AutomobileFraudMisRepresent/AutomobileFraudMisRepresent"
    ).then(({ AutomobileFraudMisRepresent }) => ({
      default: AutomobileFraudMisRepresent,
    }))
  )
);
const AutomobileDriverClaim = Loadable(
  lazy(() =>
    import(
      "./AutomobileDriver/AutomobileDriverClaims/AutomobileDriverClaimsTabs"
    ).then(({ AutomobileClaimTabs }) => ({
      default: AutomobileClaimTabs,
    }))
  )
);
const AutomobileDriverConviction = Loadable(
  lazy(() =>
    import(
      "./AutomobileDriver/AutomobileDriverConviction/AutomobileDriverConvictionPage"
    ).then(({ AutomobileDriverConvictionPage }) => ({
      default: AutomobileDriverConvictionPage,
    }))
  )
);
const AutomobileDriverActivity = Loadable(
  lazy(() =>
    import(
      "./AutomobileDriver/AutomobileDriverActivity/AutomobileDriverActivity"
    ).then(({ AutomobileActivityInformation }) => ({
      default: AutomobileActivityInformation,
    }))
  )
);
const AutomobileQuoteList = Loadable(
  lazy(() =>
    import(
      "./AutomobileQuote/AutomobileQuoteList"
    ).then(({ AutomobileQuoteList }) => ({
      default: AutomobileQuoteList,
    }))
  )
);
const AutomobileQuote = Loadable(
  lazy(() =>
    import(
      "./AutomobileQuote/AutomobileQuote"
    ).then(({ AutomobileQuote }) => ({
      default: AutomobileQuote,
    }))
  )
);
const AutomobileQuoteProccess = Loadable(
  lazy(() =>
    import(
      "./AutomobileQuote/AutomobileQuoteProccess"
    ).then(({ AutomobileQuoteProccess }) => ({
      default: AutomobileQuoteProccess,
    }))
  )
);
const AutomobileAllTask = Loadable(
  lazy(() =>
    import(
      "./AutomobilePolicyNotes/AutomobileActivitiesTabs"
    ).then(({ AutomobileActivitiesTabs }) => ({
      default: AutomobileActivitiesTabs,
    }))
  )
);
const AutomobileAuthorization = Loadable(
  lazy(() =>
    import(
      "./AutomobileAuthorizationForm/AuthorizationForm"
    ).then(({ AutomobileAuthorization }) => ({
      default: AutomobileAuthorization,
    }))
  )
);
const AutomobileCancellation = Loadable(
  lazy(() =>
    import(
      "./AutomobileCancellation/AutomobileCancellation"
    ).then(({ AutomobileCancellation }) => ({
      default: AutomobileCancellation,
    }))
  )
);
const AutomobileSupplementaryForm = Loadable(
  lazy(() =>
    import(
      "./AutomobilePolicyForms/AutomobileSupplementaryForm/AutomobileSupplementaryTab"
    ).then(({ AutomobileSupplementaryForm }) => ({
      default: AutomobileSupplementaryForm,
    }))
  )
);
const AutomobileCSIOApplicationForm = Loadable(
  lazy(() =>
    import(
      "./AutomobileCSIOApplicationForm/AutomobileCSIOApplicationStepTab"
    ).then(({ AutomobileCSIOApplicationForm }) => ({
      default: AutomobileCSIOApplicationForm,
    }))
  )
);
const AutomobileInvoiceList = Loadable(
  lazy(() =>
    import(
      "./AutomobileInvoices/AutomobileInvoiceTabs"
    ).then(({ AutomobileInvoiceTabs }) => ({
      default: AutomobileInvoiceTabs,
    }))
  )
);
const AutomobileCSIOMpoiWrapper = Loadable(
  lazy(() =>
    import(
      "./AutomobileCSIOMpoi/AutomobileCSIOMpoiWrapper"
    ).then(({ AutomobileCSIOMpoiWrapper }) => ({
      default: AutomobileCSIOMpoiWrapper,
    }))
  )
);
const AutomobileInvoiceHistoryWrapper = Loadable(
  lazy(() =>
    import(
      "./AutomobileInvoices/AutomobileInvoiceHistoryWrapper"
    ).then(({ AutomobileInvoiceHistoryWrapper }) => ({
      default: AutomobileInvoiceHistoryWrapper,
    }))
  )
);
const AutomobileInvoiceWrapper = Loadable(
  lazy(() =>
    import(
      "./AutomobileInvoices/AutomobileInvoiceWrapper"
    ).then(({ AutomobileInvoiceWrapper }) => ({
      default: AutomobileInvoiceWrapper,
    }))
  )
);
const AutomobileBulkInvoiceWrapper = Loadable(
  lazy(() =>
    import(
      "./AutomobileInvoices/AutomobileBulkInvoiceWrapper"
    ).then(({ AutomobileBulkInvoiceWrapper }) => ({
      default: AutomobileBulkInvoiceWrapper,
    }))
  )
);
const AutomobileInvoicePaymentList = Loadable(
  lazy(() =>
    import(
      "./AutomobileInvoices/AutomobileInvoicePaymentList"
    ).then(({ AutomobileInvoicePaymentList }) => ({
      default: AutomobileInvoicePaymentList,
    }))
  )
);
const AutomobileInvoicePaymentWrapper = Loadable(
  lazy(() =>
    import(
      "./AutomobileInvoices/AutomobileInvoicePaymentWrapper"
    ).then(({ AutomobileInvoicePaymentWrapper }) => ({
      default: AutomobileInvoicePaymentWrapper,
    }))
  )
);
const AutomobilePolicyChangeReqList = Loadable(
  lazy(() =>
    import(
      "./AutomobilePolicyChangeRequest/AutomobilePolicyChangeList"
    ).then(({ AutomobilePolicyChangeList }) => ({
      default: AutomobilePolicyChangeList,
    }))
  )
);
const AutomobileApplicationForm = Loadable(
  lazy(() =>
    import(
      "./AutomobileApplicationForm/AutomobileApplicationStepsTab"
    ).then(({ AutomobileApplicationForm }) => ({
      default: AutomobileApplicationForm,
    }))
  )
);
const AutomobileAlbertaApplicationForm = Loadable(
  lazy(() =>
    import(
      "./AutomobileAlbertaApplicationForm/AutomobileAlbertaApplicationStepsTab"
    ).then(({ AutomobileAlbertaApplicationForm }) => ({
      default: AutomobileAlbertaApplicationForm,
    }))
  )
);
const AutomobileLiabilitySLips = Loadable(
  lazy(() =>
    import(
      "./LiabilitySlips/LiabilitySlipsWrapper"
    ).then(({ AutomobileLiabilitySlipsWrapper }) => ({
      default: AutomobileLiabilitySlipsWrapper,
    }))
  )
);
const AutomobileCSIOCertificat = Loadable(
  lazy(() =>
    import(
      "./CSIOCertificate/CSIOCertificate"
    ).then(({ CSIOCertificate }) => ({
      default: CSIOCertificate,
    }))
  )
);
const AutomobileOPCF16 = Loadable(
  lazy(() =>
    import(
      "./OPCF_16/OPCF_16"
    ).then(({ OPCF_16 }) => ({
      default: OPCF_16,
    }))
  )
);
const AutomobileOPCF17 = Loadable(
  lazy(() =>
    import(
      "./OPCF_17/OPCF_17"
    ).then(({ OPCF_17 }) => ({
      default: OPCF_17,
    }))
  )
);
const AutomobileOPCF28A = Loadable(
  lazy(() =>
    import(
      "./OPCF_28A/OPCF_28A"
    ).then(({ OPCF_28A }) => ({
      default: OPCF_28A,
    }))
  )
);
const AutomobileAttachmentList = Loadable(
  lazy(() =>
    import(
      "./AutomobileBasicDetails/Attachment/AttachmentList"
    ).then(({ AutomobileAttachmentList }) => ({
      default: AutomobileAttachmentList,
    }))
  )
);
const AutomobilePolicyNotesList = Loadable(
  lazy(() =>
    import(
      "./AutomobilePolicyNotes/AutomobilepolicyNotesList"
    ).then(({ AutomobilePolicyNotesList }) => ({
      default: AutomobilePolicyNotesList,
    }))
  )
);
const AutomobilePolicyNoteForm = Loadable(
  lazy(() =>
    import(
      "./AutomobileNoteForm/AutomobileNoteForm"
    ).then(({ AutomobileNoteForm }) => ({
      default: AutomobileNoteForm,
    }))
  )
);
const AutomobilePolicyTelematics = Loadable(
  lazy(() =>
    import(
      "./AutomobilePolicyTelematics/AutomobilePolicyTelematics"
    ).then(({ AutomobilePolicyTelematics }) => ({
      default: AutomobilePolicyTelematics,
    }))
  )
);

const AutomobilePolicyContacts = Loadable(
  lazy(() =>
    import(
      "./AutomobilePolicyContacts/AutomobilePolicyContacts"
    ).then(({ AutomobilePolicyContacts }) => ({
      default: AutomobilePolicyContacts,
    }))
  )
);

const AutomobileCreateARSWrapper = Loadable(
  lazy(() =>
    import(
      "./AutomobileApplicationForm/AutomobileCreateARSQuote"
    ).then(({ AutomobileCreateARSWrapper }) => ({
      default: AutomobileCreateARSWrapper,
    }))
  )
);
export const AutomobileRoutes = [
{
            path: "/automobile-policy/:customerId/basic-details/",
            exact: true,
            element: (
              <AuthorizedRoute
                moduleKeys={[
                  MODULE_IDS.COMMERCIAL_AUTO,
                  MODULE_IDS.AUTO_POLICY_ADMIN_MANAGER,
                ]}
              >
                <AutomobileBasicDetails />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/basic-details/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                moduleKeys={[
                  MODULE_IDS.COMMERCIAL_AUTO,
                  MODULE_IDS.AUTO_POLICY_ADMIN_MANAGER,
                ]}
              >
                <AutomobileBasicDetails />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutoDriverRoot />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/driver-information",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverInformation />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/driver-information/:driverNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverInformation />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/insurance-lapse",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileInsuranceLapse />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/insurance-lapse/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileInsuranceLapse />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/fraud",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileFraudMisRepresent />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/fraud/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileFraudMisRepresent />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/claims",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverClaim />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/claims/:claimNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverClaim />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/conviction",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverConviction />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/conviction/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverConviction />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/activity-task",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverActivity />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/driver-tab/:customerPolicyId/activity-task/:taskNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileDriverActivity />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/quote/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileQuoteList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/quote/:customerPolicyId/manage-quote",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileQuote />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/quote/:customerPolicyId/manage-quote/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileQuote />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/quote/:customerPolicyId/manage-quote/:code/quote-preview",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileQuoteProccess />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/vehicle-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutoVehicleRoot />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/vehicle-tab/:customerPolicyId/vehicle-information",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileVehiclePage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/vehicle-tab/:customerPolicyId/vehicle-information/:vehicleNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileVehiclePage />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileScheduleAList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/all-tasks/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileAllTask />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/manage-coverage",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileScheduleAPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/manage-coverage/:vehicleNumber/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileScheduleAPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                {/* <AutomobilePolicyFormsRoot /> */}
                <AutomobilePolicyForms />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/authorization",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileAuthorization />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/authorization/:authNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileAuthorization />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/authorization/duplicate/:authNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileAuthorization isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCancellation />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation/duplicate/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCancellation isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileConsentForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileConsentForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileConsentForm isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/retiree-discount",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileRetireeDiscount />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/retiree-discount/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileRetireeDiscount />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/retiree-discount/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileRetireeDiscount isDuplicate/>
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/sharing-fillable",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileSharingFillable />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/sharing-fillable/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileSharingFillable />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/sharing-fillable/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileSharingFillable isDuplicate/>
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/supplementary-form",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileSupplementaryForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/supplementary-form/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileSupplementaryForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/supplementary-form/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileSupplementaryForm isDuplicate/>
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOApplicationTab />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId/application",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId/application/:messageGUID",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId/edi",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId/edi/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId/policy-change/:messageGUID",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/csio-mpoi/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <AutomobileCSIOMpoiWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/invoices/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <AutomobileInvoiceList />
              </AuthorizedRoute>
            ),
          },
          

          {
            path: "/automobile-policy/:customerId/invoices/:customerPolicyId/payment/history/:invoiceId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
                <AutomobileInvoiceHistoryWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/invoices/:customerPolicyId/manage",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
                <AutomobileInvoiceWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/invoices/:customerPolicyId/manage/:invoiceId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
                <AutomobileInvoiceWrapper />
              </AuthorizedRoute>
            ),
          },
               {
            path: "/automobile-policy/:customerId/invoices/:customerPolicyId/bulk-invoice",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
                <AutomobileBulkInvoiceWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/invoices/payments/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <AutomobileInvoicePaymentList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/invoices/:customerPolicyId/bulk-payment",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileInvoicePaymentWrapper />
              </AuthorizedRoute>
            ),
          },
          // {
          //   path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId/policy-change-req",
          //   exact: true,
          //   element: (
          //     <AuthorizedRoute moduleIds={[MODULE_IDS.AUTOMOBILE]}>
          //       <AutomobileCSIOPolicyChangeReqForm />
          //     </AuthorizedRoute>
          //   ),
          // },
          // {
          //   path: "/automobile-policy/:customerId/automobile-csio-application-tab/:customerPolicyId/policy-change-req/:messageGUID",
          //   exact: true,
          //   element: (
          //     <AuthorizedRoute moduleIds={[MODULE_IDS.AUTOMOBILE]}>
          //       <AutomobileCSIOPolicyChangeReqForm />
          //     </AuthorizedRoute>
          //   ),
          // },
          {
            path: "/automobile-policy/:customerId/csio-edocs-list/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOEDocsList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/csio-mpoi/:customerPolicyId/manage",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileMpoiWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/csio-mpoi/:customerPolicyId/manage/:requestUuid",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileMpoiWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOEDocsWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc/:type/:csioEdocsId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOEDocsWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/csio-edi-list/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOEDIList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-change-request-list/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyChangeReqList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-change-request/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyChangeReqForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-change-request/:customerPolicyId/manage/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyChangeReqForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-application-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileApplicationRoot />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-application-tab/:customerPolicyId/application",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-application-tab/:customerPolicyId/application/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileApplicationForm />
              </AuthorizedRoute>
            ),
          },
          // {
          //   path: "/automobile-policy/:customerId/automobile-alberta-application-tab/:customerPolicyId",
          //   exact: true,
          //   element: (
          //     <AuthorizedRoute moduleIds={[MODULE_IDS.AUTOMOBILE]}>
          //       <AutomobileAlbertaApplicationList />
          //     </AuthorizedRoute>
          //   ),
          // },
          {
            path: "/automobile-policy/:customerId/automobile-application-tab/:customerPolicyId/alberta-application",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileAlbertaApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/automobile-application-tab/:customerPolicyId/alberta-application/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileAlbertaApplicationForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileLiabilitySLips />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileLiabilitySLips />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileLiabilitySLips isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-insurance",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOCertificat />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-insurance/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOCertificat />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-insurance/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileCSIOCertificat isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-16",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF16 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-16/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF16 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-16/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF16 isDuplicate />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-17",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF17 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-17/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF17 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-17/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF17 isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-28A",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF28A />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-28A/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF28A />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-28A/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileOPCF28A isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/attachment-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileAttachmentList />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/automobile-policy/:customerId/policy-notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyNotesList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileNoteFormList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/notes-tab/:customerPolicyId/note",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/notes-tab/:customerPolicyId/note/:noteNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/task-activity-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobileTaskActivity />
              </AuthorizedRoute>
            ),
          },
        //   {
        //     path: "/automobile-policy/:customerId/task-activity-tab/:customerPolicyId/tasks",
        //     exact: true,
        //     element: (
        //       <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
        //         <CreateTasks
        //           fromPolicy
        //           policyType={POLICIES.AUTOMOBILE_POLICY}
        //         />
        //       </AuthorizedRoute>
        //     ),
        //   },

        //   {
        //     path: "/automobile-policy/:customerId/task-activity-tab/:customerPolicyId/tasks/:taskCode",
        //     exact: true,
        //     element: (
        //       <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
        //         <CreateTasks
        //           fromPolicy
        //           policyType={POLICIES.AUTOMOBILE_POLICY}
        //         />
        //       </AuthorizedRoute>
        //     ),
        //   },
          {
            path: "/automobile-policy/:customerId/telematics/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyTelematics />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/automobile-policy/:customerId/contacts/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                <AutomobilePolicyContacts />
              </AuthorizedRoute>
            ),
          },

           {
            path: "/automobile-policy/:customerId/automobile-application-tab/:customerPolicyId/quote-ars",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
              <AutomobileCreateARSWrapper/>
              </AuthorizedRoute>
            ),
          },

        ].concat(AutoG4SignRouter)

